import React, { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { TabsInputComponent } from "../../../../../../../component/index.jsx"
import * as Yup from "yup"
import {
  FORM_NEED,
  getMaximumErrorString,
  getMinimumErrorString,
  getStringErrorMassage
} from "../../../../../../helpers/StringCollection.js"
import swal from "sweetalert"

import { useSubheader } from "../../../../../../../_metronic/layout/index.js"
import { FormBenih } from "./step/FormBenih.jsx"
import { createCategoryItem } from "../../../../../../../redux/actions/MasterDataAction.jsx"
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers/index.js"
import { ILLUSTRATION_CONSTANTS } from "../../../../../../../constants/ImageConstants.js"
import { useTranslation } from "react-i18next"
import { RoutesConstants } from "../../../../../../../constants/RoutesConstants.js"

export const CreateSeed = ({
  history,
  match: {
    params: { subType }
  }
}) => {
  const dispatch = useDispatch()
  const subHeader = useSubheader()
  const formRef = useRef()
  const [isValid, setIsValid] = useState(true)
  const { General } = useSelector((state) => state)
  const [initialValue, setInitialValue] = useState({
    plant_type_id: "",
    type: "SEED",
    sub_type: subType.toUpperCase(),
    category_name: ""
  })
  const { t } = useTranslation()

  const [swalMessage, setSwalMessage] = useState("")
  const [swalIcon, setSwallIcon] = useState("")
  const stepsTitle = [null]
  const stepsDescription = [null]

  const createEditFlow = [<FormBenih key={0} isReadOnly={false} setIsValid={setIsValid} />]

  useEffect(() => {
    subHeader.setButton(buttonSubmited)
  }, [isValid])

  useEffect(() => {
    setInitialValue((prevState) => ({
      ...prevState
    }))
    subHeader.setButton(buttonSubmited)
    subHeader.setBreadcrumbs([
      {
        pathname: RoutesConstants.MASTER_DATA.CATEGORY_ITEM.PAGE(),
        title: t("sub_header_category_item")
      },
      {
        pathname: RoutesConstants.MASTER_DATA.CATEGORY_ITEM.NEW("seed", subType),
        title: t("sub_header_seed")
      },
      {
        title: t("sub_header_add")
      }
    ])
  }, [])

  useEffect(() => {
    if (General.isFinishUpdateOrDelete) {
      if (swalMessage) {
        swal({
          icon: swalIcon,
          text: swalMessage
        })
      }
      history.push(RoutesConstants.MASTER_DATA.CATEGORY_ITEM.NEW("seed", subType))
    }
  }, [General.isFinishUpdateOrDelete])

  const ValidationScheme = [
    Yup.object().shape({
      plant_type_id: Yup.string().required(
        getStringErrorMassage("Tipe Tanaman ", FORM_NEED.harusDiIsi)
      ),
      category_name: Yup.string()
        .min(3, getMinimumErrorString(3))
        .max(100, getMaximumErrorString(100))
        .required(getStringErrorMassage("Nama Varian ", FORM_NEED.harusDiIsi))
    })
  ]

  const buttonSubmited = (
    <button
      type="button"
      disabled={isValid}
      className={isValid ? "btn button-disabled" : "btn btn-primary"}
      onClick={() => {
        if (formRef.current && !isValid) {
          formRef.current.handleSubmit()
        }
      }}>
      Submit
    </button>
  )

  const onSubmitForm = (e) => {
    setSwalMessage(t("messages_response_add_seed_success"))
    setSwallIcon(toAbsoluteUrl(ILLUSTRATION_CONSTANTS.SUCCESS_PLACEHOLDER))
    const { values, submited } = e
    if (submited) {
      dispatch(createCategoryItem(values))
    }
  }

  return (
    <>
      <TabsInputComponent
        isEditTabs={false}
        steps={stepsTitle}
        stepDescription={stepsDescription}
        formInitialValues={initialValue}
        formId="createBenih"
        innerRef={formRef}
        componentTab={createEditFlow}
        validationSchema={ValidationScheme}
        onSubmitForm={onSubmitForm}
      />
    </>
  )
}
